export const createHalfHourIntervalsStartingFromZero = (amount: number) => {
  return Array.from(new Array(amount)).map(
    (_, index) =>
      `${index < 20 ? "0" : ""}${Math.floor(index / 2)}:${index % 2 === 0 ? "00" : "30"}`
  );
};

const AMOUNT_OF_HALF_HOUR_INTERVALS_STARTING_FROM_ZERO_TO_24: number = 24 * 2 + 1;
export const halfHourIntervalsFromZeroTo24 = createHalfHourIntervalsStartingFromZero(
  AMOUNT_OF_HALF_HOUR_INTERVALS_STARTING_FROM_ZERO_TO_24
);
